import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MargaritaFlightsComponent } from './margarita-flights.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    MargaritaFlightsComponent,
  ]
})
export class MargaritaFlightsModule { }



// WEBPACK FOOTER //
// ./src/app/margarita-flights/margarita-flights.module.ts